import { Flex, Group, Pill, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Content, EditButtonLink } from '@/core/components';

import { Faculty } from './model/FacultyTypes';

interface FacultyViewProps {
  faculty: Faculty;
}

export function FacultyView(props: FacultyViewProps) {
  const { t } = useTranslation();

  const { faculty } = props;
  const { name } = faculty;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{name}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              {/*<FacultyDeleteButton facultyId={faculty.id} /> TODO ENABLE AFTER SECURITY CHECK*/}
            </Group>
          </Flex>
        </Stack>
      </Content>

      {faculty.headOfFaculty && (
        <Content type="full">
          <Text fw="500">{t('faculties.form.fields.headOfFaculty')}</Text>
          <Group>{faculty.headOfFaculty.email}</Group>
          <Group>
            {faculty.headOfFaculty.firstName} {faculty.headOfFaculty.lastName}
          </Group>
        </Content>
      )}

      <Content type="full">
        <Text fw="500">{t('faculties.form.fields.teachersNo')}</Text>
        <Group>
          <Pill>{faculty.teachersNo}</Pill>
        </Group>
      </Content>

      <Content type="full">
        <Text fw="500">{t('faculties.form.fields.domain')}</Text>
        <Group>
          <Pill>{faculty.domain}</Pill>
        </Group>
      </Content>
    </Stack>
  );
}
